/**
 * Le Club — steps carousel.
 *
 * The track is a CSS scroll-snap list, so swiping works with no JS at all.
 * This script adds the affordances the client asked for — arrows and dots —
 * and only while the track is actually scrollable (i.e. on phones).
 */
(function () {
  'use strict';

  function initSection(root) {
    var wrap = root.querySelector('[data-leclub-steps]');
    if (!wrap) return;

    var track = wrap.querySelector('[data-leclub-track]');
    var controls = wrap.querySelector('[data-leclub-controls]');
    if (!track || !controls) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-leclub-slide]'));
    var dots = Array.prototype.slice.call(controls.querySelectorAll('.leclub-steps__dot'));
    var prev = controls.querySelector('[data-leclub-prev]');
    var next = controls.querySelector('[data-leclub-next]');
    if (slides.length < 2) return;

    var current = 0;

    function scrollable() {
      return track.scrollWidth - track.clientWidth > 8;
    }

    function syncControls() {
      var on = scrollable();
      controls.hidden = !on;
      wrap.classList.toggle('is-carousel', on);
    }

    function setCurrent(index) {
      current = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
      // Marks the step the reader is on, so its arch lights up like the
      // hovered one does on desktop.
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-current', i === current);
      });
      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === slides.length - 1;
    }

    function goTo(index) {
      var target = slides[Math.max(0, Math.min(index, slides.length - 1))];
      if (!target) return;
      // scrollIntoView would also scroll the page vertically; move the track only.
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    // Derive the active slide from scroll position rather than tracking clicks,
    // so swiping and the buttons can never disagree.
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0;
        var bestDist = Infinity;
        slides.forEach(function (slide, i) {
          var center = slide.offsetLeft - track.offsetLeft + slide.offsetWidth / 2;
          var dist = Math.abs(center - mid);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        setCurrent(best);
        ticking = false;
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.index, 10) || 0); });
      dot.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); goTo(current + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(current - 1); }
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncControls, 150);
    });

    syncControls();
    setCurrent(0);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.leclub-steps').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
